// Biryanify menu. Live items are loaded from the Happyspace Restaurant SDK
// (grouped by category into these sections); this file provides the section
// order + metadata and a full static fallback so the site never renders empty.
// tag: 'veg' | 'nonveg' drives the dietary dot. signature: home-page picks.

export type Tag = 'veg' | 'egg' | 'nonveg';

export interface MenuItem {
  name: string;
  price: number;
  tag: Tag;
  signature?: boolean;
  desc?: string;
  weekend?: boolean;
  image?: string;
  raw?: any;
}

export interface MenuSection {
  id: string;
  title: string;
  kicker: string;
  blurb?: string;
  items: MenuItem[];
}

export const MENU: MenuSection[] = [
  {
    id: "breakfast-8am-to-12pm",
    title: "Breakfast (8AM to 12PM)",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Poori", price: 9.99, tag: "veg" },
      { name: "Dibbarotte", price: 9.99, tag: "veg" },
    ],
  },
  {
    id: "idli",
    title: "Idli",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Plain Idli", price: 6.99, tag: "veg" },
      { name: "Button Idli", price: 6.99, tag: "veg" },
      { name: "Ghee Idli", price: 6.99, tag: "veg" },
      { name: "Ghee Button Idli", price: 6.99, tag: "veg" },
      { name: "Ghee Karam Idli", price: 6.99, tag: "veg" },
      { name: "Chettinadu Chitti Idli", price: 6.99, tag: "veg" },
      { name: "Sambar Idli", price: 6.99, tag: "veg" },
      { name: "Sambar Button Idli", price: 6.99, tag: "veg" },
      { name: "Tawa Idli", price: 6.99, tag: "veg" },
    ],
  },
  {
    id: "bonda",
    title: "Bonda",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Mysore Bonda", price: 6.99, tag: "veg" },
      { name: "Tawa Bonda", price: 7.99, tag: "veg" },
    ],
  },
  {
    id: "wada",
    title: "Wada",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Wada", price: 8.99, tag: "veg" },
      { name: "Sambar Wada", price: 8.99, tag: "veg" },
    ],
  },
  {
    id: "dosa",
    title: "Dosa",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Plain Dosa", price: 7.99, tag: "veg", desc: "Crispy fermented rice crêpe served with sambar and chutneys." },
      { name: "Onion Dosa", price: 8.99, tag: "veg", desc: "Paper-thin dosa topped with onions, sambar and fresh coconut chutney." },
      { name: "Guntur Karam Dosa", price: 8.99, tag: "veg", desc: "Spicy South Indian dosa with chillies, sambar and chutneys." },
      { name: "Egg Dosa", price: 10.99, tag: "nonveg", desc: "Crispy dosa filled with scrambled egg, onions and spices." },
      { name: "Onion Masala Dosa", price: 9.99, tag: "veg", desc: "Dosa filled with spiced potatoes and onions, served with sambar." },
      { name: "Rameshwaram Dosa", price: 9.99, tag: "veg", desc: "Coastal-style dosa with seafood spices and traditional condiments." },
      { name: "Rameshwaram Masala Dosa", price: 9.99, tag: "veg", desc: "Rameshwaram-style dosa with potato masala and coastal spices." },
      { name: "Masala Dosa", price: 9.99, tag: "veg", desc: "Crispy dosa stuffed with spiced potato and onions, served with sambar." },
      { name: "Mysore Masla Dosa", price: 9.99, tag: "veg", desc: "Mysore-style dosa with spicy potato filling and chutney spread." },
      { name: "Nellore Karam Dosa", price: 8.99, tag: "veg", desc: "Spicy Nellore preparation with traditional South Indian spices." },
    ],
  },
  {
    id: "uthappam",
    title: "Uthappam",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Plain Uthappam", price: 10.99, tag: "veg" },
      { name: "Onion Uthappam", price: 10.99, tag: "veg" },
      { name: "Onion Tomato Uthappam", price: 10.99, tag: "veg" },
      { name: "Mix Veg Uthappam", price: 10.99, tag: "veg" },
    ],
  },
  {
    id: "pesarattu",
    title: "Pesarattu",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Pesarattu", price: 9.99, tag: "veg" },
      { name: "Upma Pesarattu", price: 10.99, tag: "veg" },
    ],
  },
  {
    id: "ram-ki-bandi-dosa",
    title: "Ram Ki Bandi Dosa",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Pizza Dosa", price: 9.99, tag: "veg" },
      { name: "Upma Dosa", price: 9.99, tag: "veg" },
      { name: "Butter Masala Dosa", price: 9.99, tag: "veg" },
      { name: "Paneer Dosa", price: 9.99, tag: "veg", signature: true },
      { name: "Cheese Dosa", price: 9.99, tag: "veg" },
    ],
  },
  {
    id: "non-veg-breakfast",
    title: "Non Veg Breakfast",
    kicker: "Breakfast & Tiffins",
    blurb: "Idli, vada and tawa-crisp dosas — plus Ram Ki Bandi street tiffins.",
    items: [
      { name: "Poori with Chicken Curry", price: 13.99, tag: "nonveg" },
      { name: "Poori with Mutton Curry", price: 14.99, tag: "nonveg" },
      { name: "Dosa with Chicken Curry", price: 13.99, tag: "nonveg" },
      { name: "Dosa with Mutton Curry", price: 14.99, tag: "nonveg" },
      { name: "Parotta with Chicken Curry", price: 13.99, tag: "nonveg" },
      { name: "Parotta with Mutton Curry", price: 14.99, tag: "nonveg" },
      { name: "Vada with Chicken Curry", price: 13.99, tag: "nonveg" },
      { name: "Vada with Mutton Curry", price: 14.99, tag: "nonveg" },
      { name: "Idli with Chicken Curry", price: 13.99, tag: "nonveg" },
      { name: "Idli with Mutton Curry", price: 14.99, tag: "nonveg" },
    ],
  },
  {
    id: "soups",
    title: "Soups",
    kicker: "Soups & Appetizers",
    blurb: "Chilli-slicked 65s, lollipops, kebabs and seafood fry to begin.",
    items: [
      { name: "Tomato Corn Soup", price: 8.99, tag: "veg" },
      { name: "Miryala Kodi Rasam", price: 12.99, tag: "veg" },
      { name: "Mutton Marag", price: 14.99, tag: "nonveg" },
    ],
  },
  {
    id: "veg-appetizers",
    title: "Veg Appetizers",
    kicker: "Soups & Appetizers",
    blurb: "Chilli-slicked 65s, lollipops, kebabs and seafood fry to begin.",
    items: [
      { name: "Kaju Gobi 65", price: 13.99, tag: "veg" },
      { name: "Cilantro Gobi", price: 13.99, tag: "veg" },
      { name: "Crispy Chilli Corn", price: 13.99, tag: "veg" },
      { name: "Veg Manchurian", price: 13.99, tag: "veg" },
      { name: "Paneer Majestic", price: 14.99, tag: "veg" },
      { name: "Cilantro Baby Corn", price: 13.99, tag: "veg" },
      { name: "Mushroom Pepper Fry", price: 13.99, tag: "veg" },
      { name: "Chilli Soya Chaap", price: 13.99, tag: "veg" },
    ],
  },
  {
    id: "egg-appetizers",
    title: "Egg Appetizers",
    kicker: "Soups & Appetizers",
    blurb: "Chilli-slicked 65s, lollipops, kebabs and seafood fry to begin.",
    items: [
      { name: "Egg Omlette", price: 9.99, tag: "nonveg" },
      { name: "Chilli Egg", price: 13.99, tag: "nonveg" },
    ],
  },
  {
    id: "chicken-appetizers",
    title: "Chicken Appetizers",
    kicker: "Soups & Appetizers",
    blurb: "Chilli-slicked 65s, lollipops, kebabs and seafood fry to begin.",
    items: [
      { name: "Hyd Chicken 65", price: 14.99, tag: "nonveg", signature: true, desc: "Hyderabadi chicken 65 — crispy, fried and tossed with curry leaves, green chillies and spices." },
      { name: "Chicken Cheekulu", price: 14.99, tag: "nonveg", desc: "Traditional Hyderabadi rolled chicken appetizer with spices." },
      { name: "Pandem Kodi Kaju Pakodi", price: 14.99, tag: "veg", desc: "Crispy cauliflower pakora with cashew nuts." },
      { name: "Mirapakai Kodi Vepudu", price: 14.99, tag: "nonveg", desc: "Spicy green chilli chicken fry with traditional South Indian spices." },
      { name: "Chicken Majestic", price: 14.99, tag: "nonveg", desc: "Crispy fried chicken tossed with spices and curry leaves." },
      { name: "Cilantro Chicken", price: 14.99, tag: "nonveg", desc: "Fresh cilantro-infused fried chicken with aromatics." },
      { name: "Apollo Chicken", price: 14.99, tag: "nonveg", desc: "Fiery fried chicken with crushed peppercorns and spices." },
      { name: "Japan Chicken", price: 14.99, tag: "nonveg", desc: "Crispy chicken with Asian-inspired spice blend." },
      { name: "Curry Leaf Chicken", price: 14.99, tag: "nonveg", desc: "Fried chicken tossed with fresh curry leaves and aromatic spices." },
      { name: "Chicken Lollipops", price: 14.99, tag: "nonveg", signature: true, desc: "Marinated chicken drumettes, fried until crispy and glazed with spices." },
    ],
  },
  {
    id: "mutton-appetizers-goat",
    title: "Mutton Appetizers (GOAT)",
    kicker: "Soups & Appetizers",
    blurb: "Chilli-slicked 65s, lollipops, kebabs and seafood fry to begin.",
    items: [
      { name: "Pathar Ka Gosht", price: 18.99, tag: "nonveg" },
      { name: "Mutton Nalli Roast", price: 18.99, tag: "nonveg" },
      { name: "Mutton Kheema Muttilu", price: 18.99, tag: "nonveg" },
      { name: "Talawa Gosht", price: 18.99, tag: "nonveg" },
    ],
  },
  {
    id: "seafood-appetizers",
    title: "Seafood Appetizers",
    kicker: "Soups & Appetizers",
    blurb: "Chilli-slicked 65s, lollipops, kebabs and seafood fry to begin.",
    items: [
      { name: "Apollo Fish", price: 16.99, tag: "nonveg" },
      { name: "Lemon Pepper Fish", price: 16.99, tag: "nonveg" },
      { name: "Bhimavaram Royyala Vepudu", price: 16.99, tag: "nonveg" },
      { name: "Cilantro Shrimp", price: 16.99, tag: "nonveg" },
      { name: "Kaju Shrimp Pakodi", price: 16.99, tag: "nonveg" },
    ],
  },
  {
    id: "veg-entrees",
    title: "Veg Entree's",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Dhaba Dal Tadka", price: 11.99, tag: "veg" },
      { name: "Paneer Tikka Masala", price: 14.99, tag: "veg" },
      { name: "Kadai Paneer", price: 14.99, tag: "veg" },
      { name: "Methi Chaman", price: 14.99, tag: "veg" },
      { name: "Okra Fry", price: 13.99, tag: "veg" },
      { name: "Kaju Tomato Masala", price: 13.99, tag: "veg" },
      { name: "Veg Kholapuri", price: 13.99, tag: "veg" },
      { name: "Mushroom Masala", price: 13.99, tag: "veg" },
      { name: "Egg Burji", price: 13.99, tag: "nonveg" },
      { name: "Egg Masala", price: 13.99, tag: "nonveg" },
    ],
  },
  {
    id: "chicken-entrees",
    title: "Chicken Entree's",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Butter Chicken", price: 14.99, tag: "nonveg" },
      { name: "Dum Ka Chicken", price: 14.99, tag: "nonveg" },
      { name: "Afghani Chicken", price: 14.99, tag: "nonveg" },
      { name: "Mughlai Chicken", price: 14.99, tag: "nonveg" },
      { name: "Rambha Chicken", price: 14.99, tag: "nonveg" },
      { name: "Chicken Karahi", price: 14.99, tag: "nonveg" },
    ],
  },
  {
    id: "murgh-musallam",
    title: "Murgh Musallam",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Murgh Musallam (Half)", price: 19.99, tag: "nonveg" },
      { name: "Murgh Musallam (Full)", price: 29.99, tag: "nonveg" },
      { name: "Murgh Musallam (Half)", price: 19.99, tag: "nonveg" },
      { name: "Murgh Musallam (Full)", price: 29.99, tag: "nonveg" },
    ],
  },
  {
    id: "mutton-entrees-goat",
    title: "Mutton Entree's (GOAT)",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Telangana Mutton", price: 18.99, tag: "nonveg" },
      { name: "Shahi Mutton", price: 18.99, tag: "nonveg" },
      { name: "Afghani Mutton", price: 18.99, tag: "nonveg" },
    ],
  },
  {
    id: "seafood-entrees",
    title: "Seafood Entree's",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Nellore Fish Pulusu", price: 16.99, tag: "nonveg" },
      { name: "Bendakaya Royyala Iguru", price: 16.99, tag: "nonveg" },
    ],
  },
  {
    id: "veg-sizzlers",
    title: "Veg Sizzlers",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Paneer Tikka Kebab", price: 14.99, tag: "veg" },
      { name: "Mushroom Cheese Tikka Kebab", price: 14.99, tag: "veg" },
      { name: "Churrasco Pineapple", price: 13.99, tag: "veg" },
    ],
  },
  {
    id: "non-veg-sizzlers",
    title: "Non Veg Sizzlers",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Chicken Tikka Kebab", price: 14.99, tag: "nonveg" },
      { name: "Malai Chicken Tikka Kebab", price: 14.99, tag: "nonveg" },
      { name: "Tandoori Shrimp", price: 16.99, tag: "nonveg" },
      { name: "Tandoori Pomfret", price: 19.99, tag: "nonveg" },
      { name: "Kebab Jugalbandi (Assorted Kebabs)", price: 24.99, tag: "nonveg" },
    ],
  },
  {
    id: "grilled-chicken",
    title: "Grilled Chicken",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Grilled Chicken (HALF)", price: 19.99, tag: "nonveg" },
      { name: "Grilled Chicken (FULL)", price: 29.99, tag: "nonveg" },
      { name: "Grilled Chicken (HALF)", price: 19.99, tag: "nonveg" },
      { name: "Grilled Chicken (FULL)", price: 29.99, tag: "nonveg" },
    ],
  },
  {
    id: "hyderabadi-specials",
    title: "Hyderabadi Specials",
    kicker: "Entrées & Curries",
    blurb: "Slow-simmered curries, sizzlers and Hyderabadi specials.",
    items: [
      { name: "Chicken Cheekulu", price: 14.99, tag: "nonveg" },
      { name: "Pathar Ka Gosht", price: 18.99, tag: "nonveg" },
      { name: "Rumali Roti", price: 1.99, tag: "veg" },
      { name: "Hyd Mutton Dum Biryani", price: 18.99, tag: "nonveg", signature: true },
    ],
  },
  {
    id: "chicken-biryanis",
    title: "Chicken Biryani's",
    kicker: "Biryani & Rice",
    blurb: "Long-grain basmati layered and sealed over dum.",
    items: [
      { name: "Hyderabad Chicken Dum Biryani", price: 15.99, tag: "nonveg", signature: true, desc: "Basmati layered with marinated chicken and whole spices, sealed and dum-cooked until every grain carries saffron, mint and fried onion." },
      { name: "Vijayawada Boneless Chicken Biryani", price: 16.96, tag: "nonveg", desc: "Tender boneless chicken biryani cooked in the Vijayawada style with aromatic rice and traditional spices." },
      { name: "Mughlai Chicken Biryani", price: 16.96, tag: "nonveg", desc: "Rich Mughlai-style biryani with tender chicken, basmati and royal Mughal spices." },
      { name: "Hyd Special Chicken Dum Biryani", price: 16.96, tag: "nonveg", desc: "Special Hyderabadi preparation with extra-tender chicken and aromatic dum-cooked rice." },
    ],
  },
  {
    id: "mutton-biryanis",
    title: "Mutton Biryani's",
    kicker: "Biryani & Rice",
    blurb: "Long-grain basmati layered and sealed over dum.",
    items: [
      { name: "Hyd Mutton Dum Biryani", price: 18.99, tag: "nonveg", signature: true, desc: "Tender goat biryani layered with basmati and sealed over dum, with saffron, mint and fried onions." },
      { name: "Nalli Gosht Biryani", price: 18.99, tag: "nonveg", desc: "Slow-cooked mutton bone (nalli) biryani with aromatic rice and traditional spices." },
    ],
  },
  {
    id: "veg-biryanis",
    title: "Veg Biryani's",
    kicker: "Biryani & Rice",
    blurb: "Long-grain basmati layered and sealed over dum.",
    items: [
      { name: "Veg Dum Biryani", price: 13.99, tag: "veg" },
      { name: "Paneer Dum Biryani", price: 14.99, tag: "veg" },
      { name: "Gobi 65 Biryani", price: 14.99, tag: "veg" },
      { name: "Egg Biryani", price: 14.99, tag: "nonveg" },
    ],
  },
  {
    id: "chicken-pulavs",
    title: "Chicken Pulav's",
    kicker: "Biryani & Rice",
    blurb: "Long-grain basmati layered and sealed over dum.",
    items: [
      { name: "Rajugari Kodi Pulav", price: 15.99, tag: "nonveg" },
      { name: "Palnadu Boneless Chicken Pulav", price: 16.99, tag: "nonveg" },
      { name: "Gongura Chicken Pulav", price: 16.99, tag: "nonveg" },
      { name: "Avakai Chicken Pulav", price: 16.99, tag: "nonveg" },
      { name: "Ulavacharu Chicken Pulav", price: 16.99, tag: "nonveg" },
      { name: "Chintachiguru Chicken Pulav", price: 16.99, tag: "nonveg" },
    ],
  },
  {
    id: "mutton-pulavs",
    title: "Mutton Pulav's",
    kicker: "Biryani & Rice",
    blurb: "Long-grain basmati layered and sealed over dum.",
    items: [
      { name: "Mutton Ghee Roast Pulav", price: 18.99, tag: "nonveg" },
      { name: "Mutton Kheema Pulav", price: 18.99, tag: "nonveg" },
      { name: "Gongura Mutton Pulav", price: 18.99, tag: "nonveg" },
      { name: "Ulavacharu Mutton Pulav", price: 18.99, tag: "nonveg" },
      { name: "Chintachiguru Mutton Pulav", price: 18.99, tag: "nonveg" },
    ],
  },
  {
    id: "veg-pulavs",
    title: "Veg Pulav's",
    kicker: "Biryani & Rice",
    blurb: "Long-grain basmati layered and sealed over dum.",
    items: [
      { name: "Veg Kheema Pulav", price: 13.99, tag: "veg" },
      { name: "Guthi Vankaya Pulav", price: 14.99, tag: "veg" },
      { name: "Egg Pulav", price: 14.99, tag: "nonveg" },
    ],
  },
  {
    id: "habibi-mandis",
    title: "Habibi Mandi's",
    kicker: "Mandi & Grill",
    blurb: "Smoke-kissed al faham grills, madfoon and haneeth to share.",
    items: [
      { name: "Al Faham Chicken Mandi (Grilled)", price: 19.99, tag: "nonveg", signature: true, desc: "Smoke-kissed grilled chicken served over fragrant Arabian mandi rice with tomato sauce." },
      { name: "Maqlium Chicken Mandi (Fried)", price: 19.99, tag: "nonveg", desc: "Tender fried chicken over aromatic mandi rice with traditional spices." },
      { name: "Chicken Zurbian Mandi (Juicy)", price: 19.99, tag: "nonveg", desc: "Juicy chicken mandi cooked with saffron rice and Arabian spices." },
      { name: "Al Eazm Chicken Mandi (Boneless)", price: 19.99, tag: "nonveg", desc: "Tender boneless chicken mandi served with fragrant rice and sauce." },
      { name: "Chicken Madfoon Juicy Mandi (Green Sauce)", price: 19.99, tag: "nonveg", desc: "Chicken mandi topped with green sauce (madfoon style) and aromatic rice." },
      { name: "Murgh Musallam Mandi (Full Bird)", price: 49.99, tag: "nonveg", desc: "Whole marinated bird cooked over mandi rice with royal spices — serves 2–3." },
      { name: "Mutton Madfoon Mandi", price: 21.99, tag: "nonveg", desc: "Tender goat mandi with green sauce over fragrant Arabian rice." },
      { name: "Mutton Zurbian Mandi", price: 21.99, tag: "nonveg", desc: "Slow-cooked mutton mandi with saffron rice and Arabian spices." },
      { name: "Mutton Haneeth Mandi", price: 21.99, tag: "nonveg", desc: "Haneeth-style goat mandi with caramelized onions and aromatic rice." },
      { name: "BBQ Fish Mandi", price: 19.99, tag: "nonveg", desc: "Grilled fish fillet over mandi rice with Arabian spices." },
      { name: "BBQ Prawns Mandi", price: 19.99, tag: "nonveg", desc: "Grilled prawns served over fragrant mandi rice with sauce." },
      { name: "Paneer Tikka Mandi", price: 19.99, tag: "veg", desc: "Grilled paneer tikka served over mandi rice for a vegetarian spread." },
      { name: "Egg Mandi", price: 19.99, tag: "nonveg", desc: "Egg-based mandi with rice and Arabian spices." },
      { name: "KING Mandi (8 people)", price: 129.99, tag: "nonveg", desc: "Feast-sized platter with mixed grills, whole chicken and mandi rice — feeds 8." },
    ],
  },
  {
    id: "flour-and-fire",
    title: "Flour & Fire",
    kicker: "Mandi & Grill",
    blurb: "Smoke-kissed al faham grills, madfoon and haneeth to share.",
    items: [
      { name: "Rumali Roti", price: 1.99, tag: "veg", desc: "Thin, delicate South Indian flatbread rolled with paneer and served with pickles." },
      { name: "Plain Naan", price: 2.99, tag: "veg", desc: "Soft Indian flatbread baked in the tandoor, served hot." },
      { name: "Butter Naan", price: 2.99, tag: "veg", desc: "Tandoori naan brushed with melted butter and served warm." },
      { name: "Garlic Naan", price: 3.49, tag: "veg", desc: "Garlic-infused tandoori flatbread with aromatic herbs." },
      { name: "Parotta", price: 2.99, tag: "veg", desc: "South Indian crispy layered flatbread, flaky and served warm." },
      { name: "Roti", price: 2.99, tag: "veg", desc: "Simple unleavened whole wheat flatbread, cooked fresh." },
    ],
  },
  {
    id: "shawarma",
    title: "Shawarma",
    kicker: "Street & Shawarma",
    blurb: "Shawarma wraps and the fried, tossed plates of the Indian street.",
    items: [
      { name: "Supreme Chicken Shawarma", price: 11.99, tag: "nonveg", signature: true, desc: "Hand-rolled shawarma with marinated chicken, fresh vegetables, feta and house sauce." },
      { name: "Chicken Shawarma (Mayo)", price: 11.99, tag: "nonveg", desc: "Shawarma wrap with grilled chicken, vegetables and creamy mayo." },
      { name: "Chicken Shawarma (Salad & Mayo)", price: 11.99, tag: "nonveg", desc: "Wrapped shawarma with fresh salad, chicken and mayo." },
      { name: "Chicken Shawarma (Cheese)", price: 11.99, tag: "nonveg", desc: "Melted cheese shawarma with grilled chicken and vegetables." },
      { name: "Chicken Shawarma (Cheese & Salad)", price: 11.99, tag: "nonveg", desc: "Shawarma with melted cheese, fresh salad and chicken." },
      { name: "Chicken Shawarma (Peri Peri Mayo)", price: 11.99, tag: "nonveg", desc: "Spicy peri peri mayo shawarma with grilled chicken." },
      { name: "Chicken Shawarma (Tandoori Mayo)", price: 11.99, tag: "nonveg", desc: "Tandoori mayo shawarma with marinated chicken and vegetables." },
    ],
  },
  {
    id: "street-style",
    title: "Street Style",
    kicker: "Street & Shawarma",
    blurb: "Shawarma wraps and the fried, tossed plates of the Indian street.",
    items: [
      { name: "Veg Fried Rice", price: 11.99, tag: "veg" },
      { name: "Veg Noodles", price: 11.99, tag: "veg" },
      { name: "Manchurian Fried Rice", price: 12.99, tag: "veg" },
      { name: "Gobi Fried Rice", price: 12.99, tag: "veg" },
      { name: "Gobi Noodles", price: 12.99, tag: "veg" },
      { name: "Manchurian Noodles", price: 12.99, tag: "veg" },
      { name: "Flashman Fried Rice", price: 13.99, tag: "veg" },
      { name: "Egg Fried Rice", price: 12.99, tag: "nonveg" },
      { name: "Egg Noodles", price: 12.99, tag: "nonveg" },
      { name: "Chicken Fried Rice", price: 13.99, tag: "nonveg" },
      { name: "Chicken Noodles", price: 13.99, tag: "nonveg" },
      { name: "SP Chicken Fried Rice", price: 13.99, tag: "nonveg" },
      { name: "Shrimp Fried Rice", price: 13.99, tag: "nonveg" },
      { name: "Shrimp Noodles", price: 13.99, tag: "nonveg" },
    ],
  },
  {
    id: "desserts",
    title: "Desserts",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Mango Malai", price: 6.99, tag: "veg" },
      { name: "Apricot Delight", price: 7.99, tag: "veg" },
      { name: "Alphonso Mango Tiramisu", price: 7.99, tag: "veg" },
      { name: "Double Ka Meetha", price: 5.99, tag: "veg", signature: true },
      { name: "Sitaphal Tres Leches", price: 7.99, tag: "veg" },
      { name: "Gulab Jamun with Ice Cream", price: 5.99, tag: "veg" },
    ],
  },
  {
    id: "beverages",
    title: "Beverages",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Irani Chai", price: 1.99, tag: "veg" },
    ],
  },
  {
    id: "fresh-fruit-juices",
    title: "Fresh Fruit Juices",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Orange Juice", price: 6.99, tag: "veg" },
      { name: "Pineapple Juice", price: 6.99, tag: "veg" },
      { name: "Grape Juice", price: 7.99, tag: "veg" },
      { name: "Watermelon Juice", price: 6.99, tag: "veg" },
      { name: "Chikoo Juice", price: 5.99, tag: "veg" },
      { name: "Sugarcane Juice", price: 6.99, tag: "veg" },
      { name: "Sitaphal Juice", price: 5.99, tag: "veg" },
      { name: "Guava Juice", price: 7.99, tag: "veg" },
      { name: "Pomegranate Juice", price: 7.99, tag: "veg" },
    ],
  },
  {
    id: "milkshakes",
    title: "Milkshakes",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Mango Milkshake", price: 7.99, tag: "veg" },
      { name: "Dryfruit Milkshake", price: 7.99, tag: "veg" },
      { name: "Tender Coconut Malai Milkshake", price: 8.99, tag: "veg" },
      { name: "Ice Apple Milkshake", price: 7.99, tag: "veg" },
    ],
  },
  {
    id: "fuljar-soda",
    title: "Fuljar Soda",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Jamun", price: 5.99, tag: "veg" },
      { name: "Pineapple", price: 5.99, tag: "veg" },
      { name: "Mango", price: 5.99, tag: "veg" },
    ],
  },
  {
    id: "soda-float",
    title: "Soda Float",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Coke Float.", price: 3.99, tag: "veg" },
      { name: "Orange soda Float", price: 3.99, tag: "veg" },
    ],
  },
  {
    id: "badam-milk-and-drinks",
    title: "Badam Milk & Drinks",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "Badam Milk", price: 5.99, tag: "veg" },
      { name: "Badam Fruit Mix", price: 6.99, tag: "veg" },
      { name: "Thums Up", price: 3.15, tag: "veg" },
      { name: "Coke", price: 3.15, tag: "veg" },
      { name: "Sprite", price: 3.15, tag: "veg" },
      { name: "Fanta", price: 4.5, tag: "veg" },
      { name: "Diet Coke", price: 1.99, tag: "veg" },
      { name: "Coke Zero", price: 1.99, tag: "veg" },
      { name: "Pepsi", price: 1.99, tag: "veg" },
    ],
  },
  {
    id: "kids-menu",
    title: "Kids Menu",
    kicker: "Desserts & Drinks",
    blurb: "Double ka meetha, kulfi, falooda, fresh juices and milkshakes.",
    items: [
      { name: "French Fries", price: 6.99, tag: "veg" },
      { name: "Chicken Nuggets", price: 8.99, tag: "nonveg" },
    ],
  },
];

export const SIGNATURES: MenuItem[] = MENU.flatMap((s) => s.items).filter((i) => i.signature);
export const ITEM_COUNT = MENU.reduce((n, s) => n + s.items.length, 0);
